import "../../assets/css/mywvapp.css";
import Panel from "../Panel/PanelShimmer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

export const MyWvApp = () => {
  return (
    <Panel classList="more-wv__mywvapp" shimmerProps={{height: "400px", classList: 'more-wv__mywvapp', testId: 'community-progress'}}
    showShimmer={false}>
      <h3 className="eta">We have an App, try it now</h3>
      <img src="https://wvusstatic.com/mywv/msc/feed/mywv-app-image.svg" alt="app store" />
      <p>For the first time ever you can download the new <b>My World Vision mobile app</b>. With this app, you can:</p>
      <div className="mywvapp__benefits">
        <span className="mywvapp__benefits-type"><FontAwesomeIcon icon={solid("paper-plane")} /></span><span className="mywvapp__benefits-value"> Track letters and photos</span>
        <span className="mywvapp__benefits-type"><FontAwesomeIcon icon={solid("volleyball")} /></span><span className="mywvapp__benefits-value"> See updates on your child's activities</span>
        <span className="mywvapp__benefits-type"><FontAwesomeIcon icon={solid("briefcase-medical")} /></span><span className="mywvapp__benefits-value"> View latest health reports</span>
        <span className="mywvapp__benefits-type"><FontAwesomeIcon icon={solid("graduation-cap")} /></span><span className="mywvapp__benefits-value"> Follow their education progress</span>
      </div>

      <div className="mywvapp__download">
        <a href="https://wv.link/msc-tile-ios" target="_blank" rel="noopener noreferrer" className="mywvapp__download-ios" ><img src="https://wvusstatic.com/mywv/msc/feed/apple-store-badge-bk.svg" alt="Download on the App Store"  className="mywvapp__download-ios-img"/></a>
        <a href="https://wv.link/msc-tile-android" target="_blank" rel="noopener noreferrer" className="mywvapp__download-andriod" ><img src="https://wvusstatic.com/mywv/msc/feed/google-play-badge.svg" alt="Get It On Google Play"  className="mywvapp__download-andriod-img"/></a>
      </div>
    </Panel>
  );
}

export default MyWvApp;